/* eslint-disable import/prefer-default-export */
export const idpCountries = [
  {
    label: "Bangladesh",
    value: "Bangladesh",
  },
  {
    label: "Cambodia",
    value: "Cambodia",
  },
  {
    label: "China",
    value: "China",
  },
  {
    label: "Egypt",
    value: "Egypt",
  },
  {
    label: "Ghana",
    value: "Ghana",
  },
  {
    label: "Hong Kong",
    value: "Hong Kong",
  },
  {
    label: "India",
    value: "India",
  },
  {
    label: "Indonesia",
    value: "Indonesia",
  },
  {
    label: "Kenya",
    value: "Kenya",
  },
  {
    label: "Malaysia",
    value: "Malaysia",
  },
  {
    label: "Mauritius",
    value: "Mauritius",
  },
  {
    label: "Nepal",
    value: "Nepal",
  },
  {
    label: "Nigeria",
    value: "Nigeria",
  },
  {
    label: "Oman",
    value: "Oman",
  },
  {
    label: "Pakistan",
    value: "Pakistan",
  },
  {
    label: "Philippines",
    value: "Philippines",
  },
  {
    label: "Saudi Arabia",
    value: "Saudi Arabia",
  },
  {
    label: "Singapore",
    value: "Singapore",
  },
  {
    label: "South Korea",
    value: "South Korea",
  },
  {
    label: "Sri Lanka",
    value: "Sri Lanka",
  },
  {
    label: "Taiwan",
    value: "Taiwan",
  },
  {
    label: "Thailand",
    value: "Thailand",
  },
  {
    label: "Turkey",
    value: "Turkey",
  },
  {
    label: "UAE",
    value: "UAE",
  },
  {
    label: "Vietnam",
    value: "Vietnam",
  },
];

export const utmSourceToDisplayIpdForm = ["idp-1710226103", "shreyansh-test-1716447950"];

export const indiaOfficeLocations = [
  { label: "Agra", value: "Agra" },
  { label: "Ahmedabad-CG Road", value: "Ahmedabad-CG Road" },
  { label: "Ahmedabad-SG Highway", value: "Ahmedabad-SG Highway" },
  { label: "Amritsar", value: "Amritsar" },
  { label: "Anand", value: "Anand" },
  { label: "Bangalore-JP Nagar", value: "Bangalore-JP Nagar" },
  { label: "Bangalore-St. Mark's Road", value: "Bangalore-St. Mark's Road" },
  { label: "Bangalore-Whitefield", value: "Bangalore-Whitefield" },
  { label: "Bathinda", value: "Bathinda" },
  { label: "Bhopal", value: "Bhopal" },
  { label: "Bhubaneswar", value: "Bhubaneswar" },
  { label: "Calicut", value: "Calicut" },
  { label: "Chandigarh", value: "Chandigarh" },
  { label: "Chandigarh-Sector 34", value: "Chandigarh-Sector 34" },
  { label: "Chennai-Adyar", value: "Chennai-Adyar" },
  { label: "Chennai-Nungambakkam", value: "Chennai-Nungambakkam" },
  { label: "Coimbatore", value: "Coimbatore" },
  { label: "Dehradun", value: "Dehradun" },
  { label: "Delhi-Nehru Place", value: "Delhi-Nehru Place" },
  { label: "Delhi North Campus", value: "Delhi North Campus" },
  { label: "Delhi-Rajouri Garden", value: "Delhi-Rajouri Garden" },
  { label: "Gandhinagar", value: "Gandhinagar" },
  { label: "Goa", value: "Goa" },
  { label: "Guntur", value: "Guntur" },
  { label: "Gurgaon", value: "Gurgaon" },
  { label: "Guwahati", value: "Guwahati" },
  { label: "Hoshiarpur", value: "Hoshiarpur" },
  { label: "Hubli", value: "Hubli" },
  { label: "Hyderabad-Dilsukhnagar", value: "Hyderabad-Dilsukhnagar" },
  { label: "Hyderabad-Kukatpally", value: "Hyderabad-Kukatpally" },
  { label: "Hyderabad-Somajiguda", value: "Hyderabad-Somajiguda" },
  { label: "Indore", value: "Indore" },
  { label: "Jaipur", value: "Jaipur" },
  { label: "Jalandhar", value: "Jalandhar" },
  { label: "Jammu", value: "Jammu" },
  { label: "Jodhpur", value: "Jodhpur" },
  { label: "Kakinada", value: "Kakinada" },
  { label: "Kanpur", value: "Kanpur" },
  { label: "Khanna", value: "Khanna" },
  { label: "Kochi-Edappally", value: "Kochi-Edappally" },
  { label: "Kochi-Ravipuram", value: "Kochi-Ravipuram" },
  { label: "Kolkata", value: "Kolkata" },
  { label: "Kurukshetra", value: "Kurukshetra" },
  { label: "Lucknow", value: "Lucknow" },
  { label: "Ludhiana-Feroze Gandhi Market", value: "Ludhiana-Feroze Gandhi Market" },
  { label: "Mangalore", value: "Mangalore" },
  { label: "Meerut", value: "Meerut" },
  { label: "Moga", value: "Moga" },
  { label: "Mohali", value: "Mohali" },
  { label: "Mumbai-Andheri West", value: "Mumbai-Andheri West" },
  { label: "Mumbai-Borivali", value: "Mumbai-Borivali" },
  { label: "Mumbai-Churchgate", value: "Mumbai-Churchgate" },
  { label: "Mumbai-Dadar", value: "Mumbai-Dadar" },
  { label: "Mumbai-Vashi", value: "Mumbai-Vashi" },
  { label: "Mysuru", value: "Mysuru" },
  { label: "Nagpur", value: "Nagpur" },
  { label: "Nashik", value: "Nashik" },
  { label: "Noida", value: "Noida" },
  { label: "Panchkula", value: "Panchkula" },
  { label: "Patiala", value: "Patiala" },
  { label: "Prayagraj", value: "Prayagraj" },
  { label: "Pune", value: "Pune" },
  { label: "Raipur", value: "Raipur" },
  { label: "Rajkot", value: "Rajkot" },
  { label: "Surat", value: "Surat" },
  { label: "Thane", value: "Thane" },
  { label: "Thrissur", value: "Thrissur" },
  { label: "Tirupati", value: "Tirupati" },
  { label: "Trichy", value: "Trichy" },
  { label: "Trivandrum", value: "Trivandrum" },
  { label: "Vadodara", value: "Vadodara" },
  { label: "Varanasi", value: "Varanasi" },
  { label: "Vijayawada", value: "Vijayawada" },
  { label: "Virtual Office", value: "Virtual Office" },
  { label: "Visakhapatnam", value: "Visakhapatnam" },
  { label: "Warangal", value: "Warangal" },
];
